<!--
Author: TangChen
Date: 2018-12-08
Desc: 基金转换，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-change-fund bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/cfund' }">
                    基金转换列表
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-form
            v-show="!buySuccess"
            ref="fundInfo"
            :model="fundInfo"
            :rules="rules"
            label-width="260px"
            class="pwdForm"
            inline-message
            v-on:submit.native.prevent
        >
            <el-form-item label="原基金名称：" class="form-text">
                <div v-cloak class="text-con">
                    {{ fund.fundname+'('+ (fund.fundcode === "515981" ? "515980" : fund.fundcode) +')' }}
                </div>
            </el-form-item>
            <el-form-item label="可用份额：" class="form-text red">
                <div v-cloak class="text-con">
                    {{ $util.fmtNum(fund.availablevol)+'份' }}
                </div>
            </el-form-item>
            <el-form-item label="转换渠道：" prop="transid" class="payway-list">
                <el-radio-group v-model="fundInfo.transid" class="bank-radio">
                    <el-radio
                        v-for="(bank,index) in fund.fundArr"
                        :key="index"
                        :label="bank.transid+bank.index"
                        border
                    >
                        <div class="bank-img-sel">
                            <img :src="$util.getImg(bank.paycenterid!==$util.getConfig().const.ZX_CENTER?bank.bankid:'hf')">
                            <div class="k-text-flow">
                                <span
                                    v-cloak
                                    class="bank-name"
                                    :title="$cache.getDict('110080',bank.channelid)"
                                >{{ $cache.getDict('110080',bank.channelid) }}</span>总额(份)：<span
                                    class="bank-balance"
                                >{{ $util.fmtNum(bank.availablevol) }}</span>
                            </div>
                            <i class="el-icon-check" />
                        </div>
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="转入基金：" prop="targetFund" :class="{'redemp-amount':targetFundInfo.targetfundname}">
                <el-select v-model="fundInfo.targetFund" filterable placeholder="请选择转入基金" v-on:change="selectcode">
                    <el-option
                        v-for="item in targetFunds"
                        :key="item.targetfundcode"
                        :label="item.targetfundname + '('+item.targetfundcode+')'"
                        :value="item.targetfundcode"
                    >
                        {{ item.targetfundname + '('+(item.targetfundcode === "515981" ? "515980" : item.targetfundcode)+')' }}
                    </el-option>
                </el-select>
                <!--<p v-if="targetFundInfo.targetfundname" class="redemp-prompt">-->
                <!--<i class="el-icon-warning" />预计按照{{ targetFundInfo.targetfundname+'&nbsp;'+$util.fmtDate(targetFundInfo.navdate) }}的单位净值买入-->
                <!--</p>-->
            </el-form-item>
            <el-form-item
                v-show="targetFundInfo.targetsharetype === 'A,B'"
                label="收费方式："
                prop="way"
                class="form-text"
            >
                <el-radio-group v-model="fundInfo.sharetype">
                    <el-radio label="A" name="share">
                        前收费
                    </el-radio>
                    <el-radio label="B" name="share">
                        后收费
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="转换份额：" prop="amount" :class="{'form-text':!isPwdCheck && targetFundRisk.sign}">
                <el-input
                    v-model.trim="fundInfo.amount"
                    class="prefix"
                    :placeholder="pla"
                    :maxlength="14"
                    :disabled="!targetFundInfo.targetfundname"
                />
                <span v-if="!isAmountAll&&targetFundInfo.targetfundname" class="redemp-btn" v-on:click="allSell"><span
                    class="like-a"
                    v-on:click="allSell"
                >全部份额</span></span>
            </el-form-item>
            <!-- <el-form-item v-show="feeGate.charge" label="预估手续费：" class="form-text">
                <div class="text-con" v-html="feeH" />
            </el-form-item> -->
            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd" :class="{'form-text':targetFundRisk.sign}">
                <el-input
                    v-model.trim="fundInfo.pwd"
                    type="password"
                    placeholder="请输入交易密码"
                    :maxlength="20"
                />
                <span class="redemp-btn" v-on:click.prevent="$router.push({name: 'tradepwd'})"><span class="like-a">忘记密码？</span></span>
            </el-form-item>

            <el-form-item style="margin-left:-80px">
                <div
                    v-if="readFileInfoList.length!==0"
                    class="check-box bar-pad showChenckbox"
                    style="font-size: 14px; display: flex; align-items: flex-start;"
                >
                    <div style="display: flex; align-items: flex-start;">
                        <input v-model="checkbox" type="checkbox" style="margin-top:9px" />
                        <span style="padding-left:5px;line-height:30px;width:623px">
                            本人已仔细阅读并同意本基金
                            <span v-for="(item,index) in readFileInfoList" :key="index">
                                <span v-if="$cache.getCompanyInfo().pdf_open_way === '0'">
                                    <a
                                        style="text-decoration:none; color: red"
                                        target="_blank"
                                        v-on:click="getClick(index)"
                                    >《{{ item.textname }}》</a>{{ index === readFileInfoList.length-1? "": index === readFileInfoList.length-2?"和" : "、" }}
                                </span>
                                <span v-else>
                                    <a
                                        :href="item.textaddress"
                                        style="text-decoration:none; color: red"
                                        target="_blank"
                                    >《{{ item.textname }}》</a>{{ index === readFileInfoList.length-1? "": index === readFileInfoList.length-2?"和" : "、" }}
                                </span>
                            </span>
                            等法律文件，确认是本人自主决定购买，符合本人投资目标和风险承受能力。
                        </span>
                    </div>
                </div>
            </el-form-item>

            <el-form-item>
                <div style="width:50%;">
                    <el-button
                        type="primary"
                        class="medium"
                        :disabled="checkBuy == false"
                        v-on:click="submitInfo('fundInfo')"
                    >
                        确认转换
                        <span id="time"></span>
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </div>
            </el-form-item>
            <risk-tip></risk-tip>
            <trade-apply-rule title="交易须知：" :rules="convertRules"></trade-apply-rule>
        </el-form>
        <result
            v-if="buySuccess"
            :result="result"
            v-on:return-page="$router.push({name:'traderecord'})"
            v-on:return-login="$router.push({name:'home'})"
        />
        <pdf-popup base64 :visible="pdfVisible" :need-time="needTime" :read-file-info-list="currentFileInfoList" v-on:close="finishReading"></pdf-popup>
        <fund-risk-filter v-show="!buySuccess" :qryall="qryallfund" v-on:qry-change="qryChange" />
        <fund-protocol v-model="protocol" :fund="targetFundRisk" v-on:all-read="changeFund" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
import fundProtocol from "@/components/form/fundProtocol";
import fundRiskFilter from "@/components/form/fundRiskFilter";
import cache from "@/assets/js/cache";
import PdfPopup from "@/components/util/pdfPopup";
import riskTip from "@/components/form/riskTip.vue";
import tradeApplyRule from "@/components/form/tradeApplyRule.vue";
export default {
    name: "ChangeFund",
    components: {
        PdfPopup,
        result,
        fundRiskFilter,
        fundProtocol,
        riskTip,
        tradeApplyRule
    },
    mixins: [mixin],
    data () {
        return {
            targetfundcode: "",
            feeH: "", // 费率信息
            fundInfo: {
                availablevol: "",
                amount: "",
                transid: "",
                targetFund: "",
                sharetype: "",
                pwd: ""
                // protocol: ""
            },
            checkbox: false, //阅读确认1
            checkTime: true, //阅读确认2
            checkBuy: true,
            readFileInfoList: [],//披露文件信息
            readappno: "", //申请单编号
            interval: "",
            qryallfund: "", // 适当性过滤字段
            protocol: false,
            isPwdCheck: false,
            isAmountAll: false,
            pla: "请选择转换目标基金",
            fund: {}, // 基金信息获取
            buySuccess: false, // 购买状态
            result: {// 结果页面信息
                cla: "register-success",
                msg: "您的基金转换申请已提交成功！",
                btnMsg: "预计确认时间：2018-11-16，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "查看交易记录",
                    event: "return-page"
                },
                btnR: {
                    text: "返回我的资产",
                    event: "return-login"
                }
            },
            query: null,
            targetFunds: [],
            rules: {
                amount: [
                    { validator: this.amountLimit, trigger: "blur" }
                ],
                sell: [
                    { required: true, message: "请选择取现方式", trigger: "change" }
                ],
                id: [
                    { required: true, message: "请选择取现渠道", trigger: "change" }
                ],
                pwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            limit: { min: "0.01", max: "0", text: "转换份额范围为：" },
            ZX_CENTER_ID: "",
            feeGate: {},
            targetFundInfo: {}, // 目标基金代码
            targetFundRisk: {}, // 目标基金适当性信息
            bankInfo: {},
            changecode: "",
            currentFileInfoList: [],//当前阅读信批文件
            pdfVisible: false,
            needTime: false,
            convertRules: [
                { content: "仅可转换同一基金管理人发行管理的基金" },
                { content: "转换费=转出基金的赎回费+转出与转入基金申购费（折扣前)补差（转入基金原申购费减去转出基金原申购费,具体各基金转换费的计算方法因基金公司不同规定可能略有差异)" },
                { content: "为保护长期投资者利益，根据证监会规定，对持有期较短的赎回行为，由基金公司收取≥0.5%的费用" }
            ]
        };
    },
    watch: {
        "fundInfo.transid" (val) {
            this.bankInfo = this.fund.fundArr.filter(item => {
                return item.transid + item.index === val;
            })[0];
            this.limitRefresh();
        },
        "fundInfo.targetFund" (val) {
            this.targetFundInfo = this.targetFunds.filter(item => {
                return item.targetfundcode === val;
            })[0];
            if (val !== "") {
                this.$set(this.fundInfo, "sharetype", this.targetFundInfo.targetsharetype.substr(0, 1));
            }
            this.limitRefresh();
        },
        "fundInfo.sharetype" (val) {
            if (val === "B") {
                this.feeGate = {};
            }
        },
        "fundInfo.amount" (val) {
            this.isAmount(val);
        },
        readFileInfoList: {
            handler: function (obj) {
                if (obj.length > 0 && obj.every(function (item) {
                    return item.read;//产品概要强制阅读，其他不用
                })) {
                    this.checkbox = true;
                }
            },
            deep: true
        },
        checkbox(val) {
            if (val && !this.isReadFileReading && !this.readFileInfoList[0].read) {
                this.currentFileInfoList = [this.readFileInfoList[0]];
                this.needTime = true;
                this.pdfVisible = true;
            }
            if (!val) {
                this.readFileInfoList.forEach(item => item.read = false);
            }
        }
    },
    mounted () {
        this.fund = JSON.parse(sessionStorage.getItem(this.$route.name));
        this.initFundInfo();
    },
    methods: {
        selectcode(data) {
            this.changecode = data;
            this.getFileInfo();
        },
        //获取披露文件信息
        getFileInfo() {
            if (this.changecode === "") {
                return;
            }
            this.readFileInfoList = [];
            this.$util.queryReadFileInfo({
                "tano": this.fund.tano,
                "fundcode": this.changecode,
                "flag": "0"
            }, res => {
                res.forEach(item => {
                    item.read = false;
                    if(item.texttype.trim() === "1"){//产品概要
                        this.readFileInfoList.unshift(item);
                    }else{
                        this.readFileInfoList.push(item);
                    }
                });
            });
        },
        //获取链接点击事件
        getClick(index){
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading () {
            this.pdfVisible = false;
            if (this.currentFileInfoList[0].texttype === "1") {
                this.isReadFileReading = true;
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo (formName) {
            if (this.readFileInfoList != "") {
                if (!this.checkbox) {
                    return this.$alert("根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。", "提示", {confirmButtonText: "确定"});
                }

            }
            //获取留痕申请编号
            this.$util.writeFileInfo({
                "readFileInfoList": this.readFileInfoList,
                "fundcode": this.fund.fundcode,
                "tano": this.fund.tano
            }, res => {
                this.readappno = res;
            });

            const _this = this;
            _this.$refs[formName].validate(valid => {
                if (valid) {
                    _this.$util.getSdxProtocol({ fundcode: _this.targetFundInfo.targetfundcode, proto: "convert" }, (res) => {
                        _this.targetFundRisk = res;
                        _this.protocol = true;
                    });
                } else {
                    return false;
                }
            });
        },
        // 改变风险过滤规则
        qryChange (val) {
            this.qryallfund = val;
            this.initFundInfo();
        },
        changeFund(val){
            this.protocol = false;
            if (!val) return;
            const _this = this;
            if (_this.readFileInfoList.length > 0 && _this.readappno.length === 0) {
                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
            }
            const data = {
                branchcode: _this.bankInfo.branchcode,
                transactionaccountid: _this.bankInfo.transid,
                tano: _this.bankInfo.tano,
                targetfundcode: _this.targetFundInfo.targetfundcode,
                isconvert: _this.targetFundInfo.isconvert,
                sharetype: _this.bankInfo.sharetype,
                targetsharetype: _this.fundInfo.sharetype,
                amount: _this.fundInfo.amount,
                fundcode: _this.bankInfo.fundcode,
                riskwarnflag: _this.targetFundRisk.riskwarnflag,
                riskmismatchflag: _this.targetFundRisk.riskmismatchflag,
                highriskwarnflag: _this.targetFundRisk.highriskwarnflag,
                fundmismatchflag: _this.targetFundRisk.fundmismatchflag,
                tradepwd: this.$util.enc(_this.fundInfo.pwd),
                readappno: _this.readappno
            };
            _this.$util.request("trade/convert", data, "POST").then(res => {
                if (res.data) {
                    this.result.cla = "register-success";
                    this.result.btnMsg = "预计确认：" + this.$util.fmtDate(res.data[0].cfmdate) + "， 如遇节假日则顺延";
                } else {
                    this.result.cla = "register-fail";
                    this.result.btnMsg = "原因：" + res.msg;
                }
                this.result.msg = "您的转换申请已提交" + (this.result.cla === "register-fail" ? "失败" : "成功");
                this.buySuccess = true;
            }).catch((msg)=>{
                this.$util.fundRiskCheck(_this, { fundcode: this.targetFundInfo.targetfundcode, proto: "convert" }, function (data) {
                    _this.targetFundRisk = data;
                });
            });
        },
        // 全部取现处理
        allSell () {
            this.fundInfo.amount = Number(this.bankInfo.availablevol) + "";
            this.$refs.fundInfo.validateField("amount");
            this.isAmountAll = true;
        },
        // 处理金额
        isAmount (val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                if (this.fundInfo.amount === this.bankInfo.availablevol) {
                    this.isAmountAll = true;
                } else {
                    this.isAmountAll = false;
                }
                this.queryRate();
            }, 1);
        },
        // 费率入参获取
        queryRate () {
            const _this = this;
            let _d = null;
            if (this.fundInfo.amount > 0 && this.fundInfo.sharetype === "A" && this.bankInfo.channelid && this.targetFundInfo.targetfundcode) {
                _d = {
                    fundcode: this.fund.fundcode,
                    amount: this.fundInfo.amount,
                    channelid: this.bankInfo.channelid,
                    bizcode: this.targetFundInfo.isconvert === "0" ? "8" : "7",
                    targetfundcode: this.targetFundInfo.targetfundcode
                };
            }
            this.$util.getFee(_d, res => {
                _this.feeGate = res;
                _this.feeH = "<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.charge) + "元</span>(<s>" + _this.$util.fmtNum(_this.feeGate.originfee) + "</s>元，为您节省<span class=\"red\">" + _this.$util.fmtNum(_this.feeGate.discount) + "</span>元)";
            });
        },
        amountLimit (rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 查询可转换基金
        initFundInfo () {
            const _this = this;
            this.$util.request("trade/convert/info", { qryallfund: this.qryallfund,fundcode: this.fund.fundcode, tano: this.fund.tano, fundbizflag: this.fund.fundbizflag, sharetype: this.fund.sharetype }).then(res => {
                if (res.data) {
                    this.targetFunds = res.data[0];
                    this.qryallfund = res.data[1][0].qryallfund;
                    const info = _this.$cache.getUser();
                    info.qryallfund = _this.qryallfund;
                    _this.$store.dispatch("setInfo", info);
                }
            });
            this.$set(this.fundInfo, "transid", this.fund.fundArr[0].transid + this.fund.fundArr[0].index);
            this.$set(this.fundInfo, "availablevol", this.fund.fundArr[0].availablevol);
        },
        // 获取目标基金适当性信息
        getTargetRisk (_code) {
            const _this = this;
            if (_code) {
                this.$util.fundRiskCheck(_this, { fundcode: _code, proto: "convert" }, function (data) {
                    _this.targetFundRisk = data;
                });
            }
        },
        // 获取限额
        limitRefresh () {
            if (this.bankInfo.channelid && this.targetFundInfo.targetfundcode) {
                this.queryRate();
                this.getTargetRisk(this.targetFundInfo.targetfundcode);
                this.isPwdCheck = this.$cache.getPwdCheck(this.targetFundInfo.isconvert === "0" ? "24" : "36");
                this.$util.request("trade/convert/limit", { fundcode: this.fund.fundcode, targetfundcode: this.targetFundInfo.targetfundcode, isconvert: this.targetFundInfo.isconvert }).then(res => {
                    if (res.data) {
                        const _max = Number(this.bankInfo.availablevol) > Number(res.data[0].max) ? res.data[0].max : this.bankInfo.availablevol;
                        this.$set(this.limit, "max", _max);
                        if (this.$util.fmtNum(res.data[0].min) - 0 >= this.$util.fmtNum(_max) - 0) {
                            this.$set(this.limit, "min", _max);
                            this.pla = "本次转换只能全额转换";
                        } else {
                            this.$set(this.limit, "min", res.data[0].min);
                            this.pla = "本次转换范围为" + this.$util.fmtNum(res.data[0].min) + "-" + this.$util.fmtNum(_max) + "份";
                        }
                        if (this.fundInfo.amount) {
                            this.$refs.fundInfo.validateField("amount");
                        }
                    }
                }).catch(() => { this.pla = "请选择转换目标基金"; });
            } else {
                this.pla = "请选择转换目标基金";
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-change-fund {
    padding-bottom: 30px;
    .comp-fund-risk-filter{padding: 0 20px;}
}
</style>
